import "../sass/app.scss";
import "@popperjs/core";
import * as bootstrap from "bootstrap";
import Swiper from "swiper";
import { Autoplay, Controller, Pagination, Thumbs } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/controller";
import "swiper/scss/pagination";
import "swiper/scss/thumbs";
import intlTelInput from "intl-tel-input";
import "@lottiefiles/dotlottie-wc";
import "./analytics";

$(function () {
    // Initialize dropdowns animations
    $('.dropdown').on('show.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });
    $('.dropdown').on('hide.bs.dropdown', function () {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
    });

    // Enqueue swiper's plugins
    Swiper.use([Pagination, Autoplay, Controller, Thumbs]);

    // Initialize Tiaso vertical widget's sliders
    new Swiper('.v-swiper', {
        loop: true,
        speed: 500,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        breakpoints: {
            1200: {
                direction: "vertical",
            },
        },
        autoplay: {
            delay: 8000,
        },
        on: {
            breakpoint: function (swiper) {
                if (swiper.pagination.el) {
                    swiper.pagination.el.classList.remove('swiper-pagination-vertical')
                    swiper.pagination.el.classList.remove('swiper-pagination-horizontal')
                }
                swiper.pagination.init()
            }
        }
    });

    // Initialize Tiaso horizontal widget's sliders
    const hSwiperImage = new Swiper('.h-swiper-image', {
        loop: true,
        allowTouchMove: false,
    });

    new Swiper('.h-swiper-content', {
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        autoplay: {
            delay: 5000,
        },
        controller: {
            control: hSwiperImage
        }
    });

    // Initialize Tiaso clients widget's sliders
    if (document.querySelector('.clients-swiper')) {
        const slides = document.querySelectorAll('.clients-swiper .swiper-slide').length;
        new Swiper('.clients-swiper', {
            loop: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: false
            },
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
                750: {
                    slidesPerView: Math.min(slides, 3),
                    spaceBetween: 30,
                },
                1080: {
                    slidesPerView: Math.min(slides, 4),
                    spaceBetween: 50,
                },
                1550: {
                    slidesPerView: Math.min(slides, 5),
                    spaceBetween: 90,
                },
            },
            freeMode: {
                enabled: true,
                sticky: false,
            },
            speed: 4000,
        });
    }

    // Initialize Tiaso card widget's sliders
    new Swiper('.cards-swiper', {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
    });

    if (document.querySelector(".gallery-swiper")) {
        const gallerySwiper = new Swiper(".gallery-swiper", {
            spaceBetween: 20,
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
        });
        new Swiper(".gallery-swiper-preview", {
            spaceBetween: 20,
            autoHeight: true,
            thumbs: {
                swiper: gallerySwiper,
            },
        });
    }

    // Initialize all phone inputs using ITI
    $(".phone-input").each(function () {
        intlTelInput(this, {
            initialCountry: tiaso.lang ? (tiaso.lang === "en" ? "us" : tiaso.lang) : 'fr', // Default country code to France (+33)
            separateDialCode: true, // Always display country code
            hiddenInput: () => ({
                phone: $(this).attr('name') + "_full",
                country: $(this).attr('name') + "_country"
            }),
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@20.3.0/build/js/utils.js",
            strictMode: true,
            autoPlaceholder: "off",
        });
    });

    // Initialize password strength metter
    const $passwordStrenghtContainer = $('.password-strength-container')
    $('#reg_password').on('input', function () {
        var val = this.value;
        var result = zxcvbn(val);

        // Update indicators
        if (val !== "") {
            $passwordStrenghtContainer.attr("strength", result.score).text(tiaso.zxcvbn[result.score]);
        } else {
            $passwordStrenghtContainer.removeAttr("strength", result.score).text(tiaso.zxcvbn[result.score]);
        }
    });

    // manage accordion opening here instead of letting boostrap catching the click before we stopped its propagation
    $('.tiaso-projects-list').on('click', '.accordion-button', function () {
        bootstrap.Collapse.getOrCreateInstance($($(this).attr('data-bs-target')).get(0)).toggle();
    });

    // Focus search input when modal opened
    const searchModal = document.getElementById('searchModal');
    if (searchModal) {
        searchModal.addEventListener('shown.bs.modal', () => {
            document.querySelector('#searchModal input[type="search"]').focus()
        })
    }

    // manage WP facets
    /* document.addEventListener('facetwp-loaded', function () {
        // scroll to top when listing has been reloaded
        document.querySelector('.facetwp-template').scrollIntoView({ behavior: 'smooth' });
    }); */

    // preset terms on taxonomy pages
    document.addEventListener('facetwp-loaded', function () {
        /** @see https://facetwp.com/how-to-pre-select-facet-choices/#pre-select-a-facet-choice-after-a-reset */
        if (!FWP.loaded) {
            const prefill = {
                'product-category': 'product_category',
                'uses': 'uses',
                'sectors': 'sectors',
                'types': 'types',
                'ranges': 'ranges',
                'lines': 'lines',
            };
            for (const key in prefill) {
                if (Object.hasOwnProperty.call(prefill, key)) {
                    const filter = prefill[key];
                    if (FWP_HTTP.uri.indexOf(key) > -1) {
                        console.log('yes');
                        let term = FWP_HTTP.uri.split('/').reverse()[0];
                        FWP.hooks.addAction('facetwp/reset', function () {
                            FWP.facets[filter] = [term];
                        });
                    }
                }
            }
            // and if any, force the default to products selection
            FWP.hooks.addAction('facetwp/reset', function () {
                if (document.querySelector('.facetwp-type-post_type')) {
                    FWP.facets['post_type_selector'] = ['products'];
                }
            });
        }
    });

    // manage form post on FAQ term
    document.querySelectorAll('.faq-search-form .fwp-submit').forEach((element) => {
        element.addEventListener('click', (e) => { // refresh on click
            e.preventDefault();
            if (FWP) FWP.refresh()
        })
        element.parentElement.addEventListener('submit', (e) => {
            e.preventDefault();
        })
    })

    // Initialize Boostrap's tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    // Allow to copy some content by clicking on a button
    $('button[data-copy]').click(function (e) {
        if (!navigator.clipboard || !navigator.clipboard.writeText) {
            // browser do not support copy
            $(this).remove();
            return;
        }
        e.preventDefault();
        const target = $(this).attr('data-copy');
        const targetEl = document.querySelector(target);
        if (targetEl) {
            const content = $(targetEl).text();
            navigator.clipboard.writeText(content).then(() => {
                const tooltip = bootstrap.Tooltip.getInstance(this);
                tooltip.setContent({ '.tooltip-inner': $(this).attr('data-copied-text') });
                $(this).one('hidden.bs.tooltip', () => {
                    tooltip.setContent({ '.tooltip-inner': $(this).attr('data-bs-title') });
                });
                setTimeout(() => {
                    tooltip.hide();
                }, 1500); // force hide after 2s
            })
        }
    })

    /**
     * Display variation price in another element
     */
    $('body').on('found_variation', function (e, variation) {
        console.log(variation);
        $('.summary > .price').html(variation.price_html);
    });
});
